// extracted by mini-css-extract-plugin
export default {"form":"HeaderForm_form__1EQq9"};